
<ion-app class="ion-safe-area">
  <!-- Top navigation bar (undocked) -->
  @if ((!setting.navigationSetting && routeUrl.substr(1,18) != 'reservation-iframe') && setting.configuration?.uIoptions && routeUrl.substr(1,18)  != "login-home") {
    <app-undocked-navigation-bar style="z-index: 10;"></app-undocked-navigation-bar>
  }

  

  <!-- Main split layout -->
  <ion-split-pane
    style="--side-min-width: 0px;"
    class="split-panel"
    contentId="main-content">

    @if (!this.setting.serverDown) {
      <!-- Sidebar menu -->
      @if (isTenant && routeUrl.substr(1,8) != 'waitlist' && routeUrl.substr(1,20) != 'data-privacy-contact' && routeUrl.substr(1,18) != 'reservation-iframe' && setting.navigationSetting) {
        <ion-menu #toggleMenu class="toggle-menu" contentId="main-content" type="overlay">
          <ion-header>
            <ion-toolbar class="lacademie-toolbar">
              <ion-avatar style="width:50px; height: 50px;" class="logo-icon" slot="start">
                @if (icon) {
                  <img style="border-radius: 0px; margin-left: 6px;" [src]="icon">
                }
              </ion-avatar>
              <ion-title style="font-size: 13px !important;" class="toggle-title">{{ name }}</ion-title>
              <ion-icon #menuIcon class="menu-icon extra-margin" style="width:25px; height: 25px;" slot="end" (click)="toggle()" name="menu"> </ion-icon>
            </ion-toolbar>
          </ion-header>
          <ion-content>
            @if (previewMenuMode) {
              <h3 style="text-align: center;">{{ 'General.MenuPreview' | translate | uppercase }}</h3>
            }
            <ion-list style="padding: 0px; margin-top: 0px;">
              @for (p of appPages; track p; let i = $index) {
                @if(!((p.show != undefined && !p.show(this)) || PlaceOrderStatus(p))) {
                  <!--@if(p.url != "/announcements" || (p.url == "/announcements" && setting.configuration.navBarConfiguration?.enableAnnouncements && (this.newsCategories.length > 0 || this.blogsCategories.length > 0))) {-->
                  @if(p.url != "/announcements" || (p.url == "/announcements" && setting.configuration.navBarConfiguration?.enableAnnouncements)) {
                    <!--<ion-menu-toggle [hidden]="(p.show != undefined && !p.show(this)) || PlaceOrderStatus(p)" auto-hide="false">-->
                    <ion-menu-toggle auto-hide="false">
                      @if (!IsPopup(p)) {
                        <ion-item  [routerLink]="[p.url]" style="--min-height: auto;" (click)="optionSelect(i)" routerDirection="root"  lines="none" detail="false" [class.selected]="selectedIndex == i">
                          <ion-icon size="small" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'" ></ion-icon>
                          <ion-label  style="font-size: 13px;" class="nav-title">{{ p.title | translate | uppercase }}
                            @if (p.notification > 0) {
                              <ion-badge style="margin-left:2px;">{{p.notification}}</ion-badge>
                            }
                          </ion-label>
                        </ion-item>
                      }
                      @if (IsPopup(p)) {
                        <ion-item style="--min-height: auto; cursor: pointer" (click)="ConfirmAndOpenModal(p, i)" routerDirection="root"  lines="none" detail="false" [class.selected]="selectedIndex == i">
                          <ion-icon size="small" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'" ></ion-icon>
                          <ion-label  style="font-size: 13px;" class="nav-title">{{ p.title | translate | uppercase }}
                            @if (p.notification > 0) {
                              <ion-badge style="margin-left:2px;">{{p.notification}}</ion-badge>
                            }
                          </ion-label>
                        </ion-item>
                      }
                    </ion-menu-toggle>
                  }
                  
                }
                
              }



    
              @if(!(auth.isAuthenticated || setting.configuration.hideMemberProgram)) {
                <!--<ion-menu-toggle [hidden]="auth.isAuthenticated || setting.configuration.hideMemberProgram" auto-hide="false">-->
                <ion-menu-toggle auto-hide="false">
                  @if (!IsPopup('Nav.Login')) {
                    <ion-item (click)="selectedIndex = 20" routerDirection="root" routerLink="/auth" lines="none" detail="false" [class.selected]="selectedIndex == 20">
                      <ion-icon size="small" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
                      <ion-label class="nav-title">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
                    </ion-item>
                  }
                  @if (IsPopup('Nav.Login')) {
                    <ion-item (click)="OpenLoginModal()" routerDirection="root" lines="none" detail="false" [class.selected]="selectedIndex == 20">
                      <ion-icon size="small" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
                      <ion-label class="nav-title">{{ 'Nav.Login' | translate | uppercase }}</ion-label>
                    </ion-item>
                  }
                  
                </ion-menu-toggle>
              }
              
            
              @if(auth.isAuthenticated) {
                <!--<ion-menu-toggle [hidden]="!auth.isAuthenticated" auto-hide="false">-->
                <ion-menu-toggle auto-hide="false">
                  <ion-item (click)="logout()" lines="none" detail="false">
                    <ion-icon size="small" slot="start" ios="log-out-outline" md="log-out-sharp"></ion-icon>
                    <ion-label  style="font-size: 13px;" class="nav-title">{{ 'Nav.Logout' | translate | uppercase }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }
              
            </ion-list>

            
            <ion-grid class="lang" style="text-align: center;">
              @if (supportedLanguages && supportedLanguages.length > 0) {
                <ion-row>
                  @for (language of supportedLanguages; track language) {
                    <ion-col  size="6"><a style="font-size: 13px;" (click)="changeLang(language.name)" style="text-decoration: underline; cursor: pointer; font-size: 13px !important;">{{'Language.' + language.name | translate}}</a></ion-col>
                  }
                  <!-- <ion-col size="6"><a (click)="changeLang('en')" style="text-decoration: underline; cursor: pointer;">{{'Language.English' | translate}}</a></ion-col> -->
                </ion-row>
              }
              @if (!supportedLanguages || supportedLanguages.length == 0) {
                <ion-row class="lang">
                  <ion-col size="6"><a (click)="changeLang('fr')" style="text-decoration: underline; cursor: pointer; font-size: 13px !important;">{{'Language.French' | translate}}</a></ion-col>
                  <ion-col size="6"><a (click)="changeLang('en')" style="text-decoration: underline; cursor: pointer; font-size: 13px !important;">{{'Language.English' | translate}}</a></ion-col>
                </ion-row>
              }
            </ion-grid>

            @if(facebook || instagram || twitter) {
              <div class="social-media">
                <h2 class="follow-us" style="font-size: 13px;">{{ 'Media.FollowUs' | translate }}</h2>
                <ion-grid>
                  <ion-row class="icons">
                    @if (facebook) {
                      <ion-col>
                        <a target="_blank" [href]="facebook">
                          <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
                        </a>
                      </ion-col>
                    }
                    @if (instagram) {
                      <ion-col>
                        <a target="_blank" [href]="instagram">
                          <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
                        </a>
                      </ion-col>
                    }
                    @if (twitter) {
                      <ion-col>
                        <a target="_blank" [href]="twitter">
                          <ion-icon slot="icon-only" name="logo-twitter"></ion-icon>
                        </a>
                      </ion-col>
                    }
                  </ion-row>
                </ion-grid>
              </div>
            }
            
          </ion-content>
        </ion-menu>
      }
    }

    

    <!-- Main page router outlet -->
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <!-- ✅ Mini Cookie Popup (Centered on Screen) -->
  @if (showMiniCookiePopup && !cookieConsentGiven) {
    <app-cookie-consent-popup
      (accepted)="onMiniConsentAccepted()"
      (customize)="onMiniConsentCustomize()">
    </app-cookie-consent-popup>
  }
</ion-app>
